export default "__VITE_ASSET__CmcHRQV9__"